/*
 * @Description: 转专业总人数 （Top5转入和Top5转出）
 * @Author: lisenlin
 * @Date: 2021-08-27 09:38:39
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-27 17:18:32
 */
import React from 'react'
import echarts from "echarts/lib/echarts";
import Echarts from '../../../components/common/Echarts/index'
import css from '../index.css'

export default function ChangeMajorToal(props) {
    //let total = 202;
    let top_list_import = props.importList

    let top_list_export =props.exportList

    /**
     * 构造Echarts的Option
     * @param {*} list 数据列表
     * @param {*} type import/export 
     * @returns option
     */
    const getBarOption = (list, type) => {
        let zyList = [], rsList = [];
        list.length&&list.map(item=>{
            zyList.push(item.ZYMC)
            rsList.push(item.CS)
        })
        let barColor = [
            {offset: 0, color: '#5BBDFF'},
            {offset: 0.5, color: '#5AA9FF'},
            {offset: 1, color: '#4C90FF'}
        ]
        if(type==='export') {
            barColor = [
                {offset: 0, color: '#B8E8DE'},
                {offset: 0.5, color: '#01C8A8'},
                {offset: 1, color: '#00CFBB'}
            ]
        }
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            grid: {
                left: 100,  
                right: 20,
                top: 20,  //坐标轴距离上边间距
                bottom: 30,     //坐标轴距离底部间距
            },
            xAxis: [
                {
                    type: 'value',
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                    axisLabel: {
                        show: true,
                        formatter: function(value){
                            return value.length > 7 ? value.substring(0, 7) + '...' : value;
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'category',
                    data: zyList,
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        show: true,
                        formatter: function(value){
                            return value.length > 7 ? value.substring(0, 7) + '...' : value;
                        }
                    }
                },
            ],
            series: [
                {
                    name: '人数',
                    type: 'bar',
                    data: rsList,
                    barMaxWidth: 30,    //柱体的最大宽度
                    barCategoryGap: "30%",  //不同系列的柱体间隔
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                barColor
                            ),
                            barBorderRadius: [0, 5, 5, 0]
                        }
                    },
                }
            ]
        }
    }
    return (
        <div className={css.cardWarp} >
            {/* <div className={css.titleCenter}>转专业总人数：<span className={css.count}>{total}</span></div> */}
            <div>
                <div className={css.extraTitle}>专业转入Top5</div>
                <Echarts
                    style={{height: '180px', width: '100%'}}
                    option={getBarOption(top_list_import,'import')}
                />
            </div>
            <div>
                <div className={css.extraTitle}>专业转出Top5</div>
                <Echarts
                    style={{height: '180px', width: '100%'}}
                    option={getBarOption(top_list_export,'export')}
                />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/changeMajorStaic/changeMajorTotal/index.js